(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/loader-react/assets/javascripts/loader.js') >= 0) return;  svs.modules.push('/components/components/loader-react/assets/javascripts/loader.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


(function (svs, React, PropTypes) {
  var SHOW_DELAY_MS = 200;
  var defaultSpinnerOptions = {
    lines: 12,
    length: 18,
    width: 5,
    radius: 12,
    scale: 1.0,
    corners: 1,
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    className: 'spinner',
    top: '50%,',
    left: '50%',
    shadow: false,
    hwaccel: true,
    position: 'absolute' 
  };
  var sizes = {
    100: {
      radius: 2,
      length: 3,
      width: 2,
      lines: 8
    },
    200: {
      radius: 4,
      length: 6,
      width: 2,
      lines: 10
    },
    300: {
      radius: 8,
      length: 12,
      width: 4,
      lines: 12
    }
  };
  var Loader = function (_React$Component) {
    function Loader(props) {
      var _this;
      _classCallCheck(this, Loader);
      _this = _callSuper(this, Loader, [props]);
      _this.spinnerElement = null;
      _this.spinner = null;
      _this.timeOutId = null;
      _this.getSpinnerOptions = _this.getSpinnerOptions.bind(_this);
      _this.showSpinner = _this.showSpinner.bind(_this);
      return _this;
    }
    _inherits(Loader, _React$Component);
    return _createClass(Loader, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.delay) {
          this.timeOutId = setTimeout(this.showSpinner, SHOW_DELAY_MS);
        } else {
          this.showSpinner();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.spinner) {
          this.spinner.stop();
        }
        clearTimeout(this.timeOutId);
        this.timeOutId = null;
      }
    }, {
      key: "getSpinnerOptions",
      value: function getSpinnerOptions() {
        var _this$props = this.props,
          size = _this$props.size,
          inverted = _this$props.inverted;
        return _objectSpread(_objectSpread({}, defaultSpinnerOptions), {}, {
          color: inverted ? '#323233' : '#e1e1e5',
          radius: sizes[size].radius,
          length: sizes[size].length,
          width: sizes[size].width,
          lines: sizes[size].lines
        });
      }
    }, {
      key: "showSpinner",
      value: function showSpinner() {
        this.spinner = new Spinner(this.getSpinnerOptions()).spin(this.spinnerElement);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var containerClass = this.props.className ? "".concat(this.props.className, "-loader-container") : 'loader-container-react';
        var spinnerClass = this.props.className ? "".concat(this.props.className, "-loader") : 'loader-react';
        return React.createElement("div", {
          className: containerClass
        }, React.createElement("div", {
          className: spinnerClass,
          ref: function ref(spinner) {
            _this2.spinnerElement = spinner;
          }
        }));
      }
    }]);
  }(React.Component);
  Loader.defaultProps = {
    className: '',
    delay: true,
    inverted: false,
    size: 300
  };
  svs.components.ReactLoader.Loader = Loader;
})(svs, React, PropTypes);

 })(window);